export default "__VITE_ASSET__BK_ZyQaO__ 1300w";